/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Insert_Start_TcInputs */



/**
* | output |
* | --- |
* | "Insert Start TC On Insert" |
*
* @param {Options_Editor_Insert_Start_TcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_insert_start_tc = /** @type {((inputs?: Options_Editor_Insert_Start_TcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Insert_Start_TcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer le TC de début à l'insertion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einfügen Start TC Bei Einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci Avvia TC All'inserimento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте кнопку Start TC при вставке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar inicio TC en inserción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入开始 TC 插入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("挿入開始TC挿入時")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इंसर्ट स्टार्ट टीसी ऑन इंसर्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir Iniciar TC em Inserir")
	return /** @type {LocalizedString} */ ("Insert Start TC On Insert")
});